import {
  GET_USERS,
  GET_USERS_FAIL,
  GET_USERS_SUCCESS,
  CLEAR_USERS,
  GET_USER_DETAIL,
  GET_USER_DETAIL_SUCCESS,
  GET_USER_DETAIL_FAIL,
  CLEAR_USER_DETAIL,
  MANAGE_USER,
  MANAGE_USER_SUCCESS,
  MANAGE_USER_FAIL,
  CLEAR_MANAGE_ERROR,
  GET_AUTHORIZATION_GROUPS,
  GET_AUTHORIZATION_GROUPS_SUCCESS,
  GET_AUTHORIZATION_GROUPS_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  users: [],
  user: {},
  authorizationGroups: [],
  error: {},
  manageError: null,
  loading: false,
  creationSuccess: null,
}

const users = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USERS:
      return {
        ...state,
        loading: true,
      }

    case GET_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload,
        loading: false,
      }

    case GET_USERS_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case CLEAR_USERS:
      return {
        ...state,
        users: [],
      }

    case GET_USER_DETAIL:
      return {
        ...state,
        loading: true,
      }

    case GET_USER_DETAIL_SUCCESS:
      return {
        ...state,
        user: action.payload,
        loading: false,
      }

    case GET_USER_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case CLEAR_USER_DETAIL:
      return {
        ...state,
        user: {},
        creationSuccess: null,
      }

    case MANAGE_USER:
      return {
        ...state,
        loading: true,
        manageError: null,
      }

    case MANAGE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        creationSuccess: action.payload,
        error: {},
        manageError: null,
      }

    case MANAGE_USER_FAIL:
      return {
        ...state,
        manageError: action.payload,
        loading: false,
        creationSuccess: null,
      }

    case GET_AUTHORIZATION_GROUPS:
      return {
        ...state,
        loading: true,
      }

    case GET_AUTHORIZATION_GROUPS_SUCCESS:
      return {
        ...state,
        authorizationGroups: action.payload,
        loading: false,
      }

    case GET_AUTHORIZATION_GROUPS_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case CLEAR_MANAGE_ERROR:
      return {
        ...state,
        manageError: null,
      }

    default:
      return state
  }
}

export default users
